import React, { type HTMLAttributes } from 'react';
import { css } from 'styled-components';
import { IconCircleInfoSolid } from '@/app/common/icons/libraryIcons';
import { useTranslation } from '@/app/components/translations/Translation';
import Message from '@/app/components/hotel-detail/Message';
import { Text } from '@lmn/design-system';

const MessageIcon = () => (
  <IconCircleInfoSolid
    css={css`
      color: ${({ theme }) => theme.commons.colors.warning600};
    `}
  />
);

type DestinationWithoutAirportMessageProps = {
  destination: string;
} & HTMLAttributes<HTMLElement>;

export default function DestinationWithoutAirportMessage(props: DestinationWithoutAirportMessageProps) {
  const { destination, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Message
      {...rest}
      icon={MessageIcon}
      isDismissable={false}
      css={css`
        background-color: ${({ theme }) => theme.commons.colors.warning50};
        border: 1px solid ${({ theme }) => theme.commons.colors.warning600};
      `}
    >
      <Text
        variant="Body"
        css={css`
          color: ${({ theme }) => theme.commons.colors.warning600};
        `}
      >
        {t('vacation.select.flight.message.island_no_airport', { DESTINATION: destination })}
      </Text>
    </Message>
  );
}
